<div class="dialog-header">
  <h2>{{ dialogTitle }}</h2>
  <ng-icon name="heroXMark" (click)="onCancel()" class="cursor-pointer"></ng-icon>
</div>
<form [formGroup]="noteForm" (ngSubmit)="onSave()">
  <mat-dialog-content>
    <div class="dense-2">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Note Title</mat-label>
        <input matInput formControlName="note" [errorStateMatcher]="matcher" placeholder="Enter note title">
        <mat-error *ngIf="noteForm.get('note')?.hasError('required')">
          Note Title is required
        </mat-error>
      </mat-form-field>
    </div>
    <div class="dense-2">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Note Description</mat-label>
        <textarea matInput formControlName="comments" cdkTextareaAutosize 
          cdkAutosizeMinRows="3" cdkAutosizeMaxRows="8" 
          placeholder="Enter note description (optional)"></textarea>
      </mat-form-field>
    </div>
  </mat-dialog-content>
  <mat-divider></mat-divider>
  <mat-dialog-actions align="end">
    <button mat-raised-button type="button" (click)="onCancel()" color="primary" class="outlined-btn">
      Cancel
    </button>
    <button color="accent" mat-raised-button class="ml-3" [disabled]="isLoading || !noteForm.valid" type="submit">
      Save
      <mat-icon matSuffix *ngIf="isLoading"><mat-spinner diameter="18"></mat-spinner></mat-icon>
    </button>
  </mat-dialog-actions>
</form>

